import cn from 'classnames';
import { type ComponentPropsWithRef } from 'react';
import Modal from 'react-modal';
import { Logo } from '@features/common';
import { Close } from '@shared/assets';
import { IconButton, TextButton } from '@shared/ui';
import * as st from './ModalSmall.module.scss';

interface Props {
  needClose?: boolean;
  isOpen: boolean;
  title?: string;
  onRequestClose?: () => void;
  children: React.ReactNode;
  darkOverlay?: boolean;
  className?: string;
  overlayClassName?: string;
  titleClassName?: string;
  modalBodyClassName?: string;
  buttonInHeader?: ComponentPropsWithRef<'button'>;
}

const ModalSmall = ({
  needClose,
  isOpen,
  title,
  onRequestClose,
  children,
  darkOverlay,
  className,
  overlayClassName,
  titleClassName,
  modalBodyClassName,
  buttonInHeader,
}: Props) => {
  const onAfterOpen = () => {
    document.body.style.overflow = 'hidden';
  };

  const onAfterClose = () => {
    document.body.style.overflow = 'auto';
  };

  return (
    <Modal
      onAfterOpen={onAfterOpen}
      onAfterClose={onAfterClose}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      ariaHideApp={false}
      className={cn(st.modal, className)}
      overlayClassName={cn(st.overlay, darkOverlay && st.dark, overlayClassName)}
    >
      <div className={st.head}>
        {needClose && (
          <IconButton variant="white" onClick={onRequestClose} className={st.close}>
            <Close />
          </IconButton>
        )}
        <span className={cn(st.head__title, titleClassName)}>{title ? title : <Logo />}</span>
        {buttonInHeader && (
          <TextButton
            type="button"
            {...buttonInHeader}
            className={cn(st.button, buttonInHeader.className)}
          />
        )}
      </div>
      <div className={modalBodyClassName}>{children}</div>
    </Modal>
  );
};

export default ModalSmall;
